import { Link } from "react-router-dom";

const entries = [
  {
    type: "movie",
    name: "电影",
    desc: "高分佳作 · 类型齐全",
    icon: "ri-film-line",
    count: "10 部在映",
  },
  {
    type: "tv",
    name: "电视剧",
    desc: "全集更新 · 追剧不停",
    icon: "ri-tv-2-line",
    count: "9 部热播",
  },
  {
    type: "variety",
    name: "综艺",
    desc: "轻松解压 · 欢乐陪伴",
    icon: "ri-mic-line",
    count: "5 档热综",
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 md:px-6 pt-10 md:pt-14">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-14 w-14 md:h-16 md:w-16 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className={`${entry.icon} text-2xl md:text-3xl`} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {entry.name}
                </h3>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                  {entry.count}
                </span>
              </div>
              <p className="mt-1 text-xs md:text-sm text-foreground-600">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-line text-lg text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
          </Link>
        ))}
      </div>
    </section>
  );
}